import Styles from "./style.module.scss";
import React from "react";
import { IPacket, PropsPacketsInBasket } from "../../../../types";
import { Link } from "react-router-dom";

const formatPackageSummary = (summary: string): string =>
  summary
    .replace(/^1 hr\b/, "1 hour")
    .replace(/\bhr\b/, "hours")
    .replace(/·\s*(\d+)\s*$/, "· $1 digital images");

const PacketsInBasket: React.FC<PropsPacketsInBasket> = ({ packetInBasket, onClickDeletePacket }) => {
  const handleDeletePackets = (packetId: string): void => {
    onClickDeletePacket(packetId);
  };

  return (
    <div className={Styles.packetsInBasket}>
      {packetInBasket.map((packet: IPacket) => (
        <article className={Styles.packetsInBasket__card} key={packet._id}>
          <img
            className={Styles.packetsInBasket__image}
            src={packet.image}
            alt={packet.imageDescription || `${packet.namePacket} photography package`}
          />
          <div className={Styles.packetsInBasket__details}>
            <h2 className={Styles.packetsInBasket__name}>
              <Link
                to={`/prices/${
                  packet.photosessionType === "event" ? "family" : packet.photosessionType.toLowerCase()
                }/#${packet._id}`}
                title={`View details for ${packet.namePacket}`}
              >
                {packet.namePacket}
              </Link>
            </h2>
            <p className={Styles.packetsInBasket__category}>{packet.photosessionType} photography session</p>
            {packet.shortDescription && (
              <p className={Styles.packetsInBasket__description}>{formatPackageSummary(packet.shortDescription)}</p>
            )}
            <button
              type="button"
              className={Styles.packetsInBasket__remove}
              onClick={() => handleDeletePackets(packet._id)}
              aria-label={`Remove ${packet.namePacket} from your selection`}
            >
              Remove
            </button>
          </div>
          <strong className={Styles.packetsInBasket__price}>${packet.price}</strong>
        </article>
      ))}
    </div>
  );
};

export default PacketsInBasket;
